import React, { useState } from "react";
import { motion } from "framer-motion";
import { containerVariants } from "../signup/motion";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Step2 = ({ setStep, tempToken }) => {
  const [code, setCode] = useState(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleCodeChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;
    const newCode = [...code];
    newCode[index] = value.slice(-1);
    setCode(newCode);

    if (value && index < 5) {
      const nextInput = document.getElementById(`code-${index + 1}`);
      nextInput?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !code[index] && index > 0) {
      const prevInput = document.getElementById(`code-${index - 1}`);
      prevInput?.focus();
    }
  };

  const handleCodeSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const enteredCode = code.join("");

    if (enteredCode.trim() === "") {
      setError("Please enter the verification code.");
      setLoading(false);
      return;
    }

    if (enteredCode.length < 6) {
      setError("Enter a 6-digit verification code.");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/api/user/verifyEmail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tempToken}`,
        },
        body: JSON.stringify({ code: Number(enteredCode) }),
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Verification failed");
      }
      // console.log("email verified successfully")
      setStep(3)
    } catch (err) {
      setError(err.message || "An unexpected error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div
      key="code"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="bg-white py-8 px-10 rounded-sm shadow-custom border border-[#2A3D66]/40 w-full max-w-xl"
    >
      <h2 className="text-2xl mb-2">Enter Code</h2>
      <p className="text-gray-600 mb-6">You will receive a 6-digit code via email</p>
      <form onSubmit={handleCodeSubmit}>
        <div className="flex justify-center gap-2 mb-6">
          {code.map((digit, index) => (
            <input
              key={index}
              id={`code-${index}`}
              type="text"
              inputMode="numeric"
              maxLength={1}
              autoComplete="off"
              value={digit}
              onChange={(e) => handleCodeChange(index, e.target.value)}
              onKeyDown={(e) => handleKeyDown(index, e)}
              className="w-9 md:w-12 h-9 md:h-12 text-center text-lg md:text-2xl border-b-2 md:border-b-4 border-gray-300 outline-none focus:border-[#036494]"
            />
          ))}
        </div>
        <div className="w-full flex items-center justify-center">
          {loading ? (
            <button
              className="w-[132.4px] h-[40px] bg-[#036494] rounded-full flex items-center justify-center"
              disabled
            >
              <span className="loader"></span>
            </button>
          ) : (
            <button
              type="submit"
              className="w-max px-6 bg-[#036494] text-white py-2 rounded-full hover:bg-[#025177] transition-colors font-light"
            >
              Enter Code
            </button>
          )}
        </div>
        {error && <p className="text-red-500 text-sm text-center mt-2">{error}</p>}
      </form>
    </motion.div>
  );
};

export default Step2;